var EmailDashboardOverdueModule = (function () {
    function EmailDashboardOverdueModule() {
    }
    return EmailDashboardOverdueModule;
}());
export { EmailDashboardOverdueModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard-overdue/email-dashboard-overdue.module.ts.pre-build-optimizer.js